import type { JSX } from 'react';

import { TeamMembers } from './components/TeamMembers';

export function PageBody(): JSX.Element {
	return (
		<div className="container">
			<TeamMembers />
		</div>
	);
}
